import { FormMetaData } from "@/store/formCreator/types";

export const encodeFormMetaData = (metaData: FormMetaData): string | null => 
    metaData && Buffer.from(JSON.stringify(metaData)).toString('base64')

